import React, { Suspense } from 'react';
import { CircularProgress } from '@mui/material';

const LoaderLayout = ({ children }) => (
    <div
        style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}
    >
        {children}
    </div>
);

const SuspenseLoader = ({ children, fallbackLoader }) => (
    <Suspense fallback={<LoaderLayout>{fallbackLoader ?? <CircularProgress size={40} />}</LoaderLayout>}>{children}</Suspense>
);

export default SuspenseLoader;
